import {Axios} from "axios";
import {CatalogValueDto} from "./CatalogValueDto";
import {CatalogType} from "./CatalogType";

export class CatalogApiClient {

    constructor(private readonly axios: Axios) {
    }

    findDocumentTypes(): Promise<CatalogValueDto[]> {
        return new Promise((resolve, reject) => {
            this.axios.get<CatalogValueDto[]>(`/catalogs/document-types`)
                .then((response) => resolve(response.data as CatalogValueDto[]))
                .catch((error) => reject(error));
        });
    }

    findCatalogValues(catalogType: CatalogType): Promise<CatalogValueDto[]> {
        return new Promise((resolve, reject) => {
            this.axios.get<CatalogValueDto[]>(this.resolveCatalogEndpoint(catalogType))
                .then((response) => resolve(response.data as CatalogValueDto[]))
                .catch((error) => reject(error));
        });
    }

    private resolveCatalogEndpoint(catalogType: CatalogType): string {
        return "/catalogs/" + catalogType;
    }
}
